export const EVENT_KEY = {
    // 切换学校
    authSchool: 'authSchool',
    // 切换下单地址
    changeOrderAddress: 'changeOrderAddress'
}

export const CONST_KEY = {
    userLoginOut: 'userLoginOut'
}
